import React, { useState } from 'react'
import { ThemeProvider } from 'styled-components'
import VideoModal from '../components/VideoModal/VideoModal'
import ClubBanner from '../components/ClubBanner/ClubBanner'
import HowItWorks from '../components/HowItWorks/HowItWorks'
import KitPreview from '../components/KitPreview/KitPreview'
import PreviousKits from '../components/PreviousKits/PreviousKits'
import NextKit from '../components/NextKit/NextKit'
import TAGTopics from '../components/TAGTopics/TAGTopics'
import ClubSubscription from '../components/ClubSubscription/ClubSubscription'
import ClubTest from '../components/ClubTest/ClubTest'
import Footer from '../components/Footer/Footer'
import { clubBannerIneditosData } from '../components/ClubBanner/ClubBannerData'
import { howItWorksIneditosDefautlData } from '../components/HowItWorks/HowItWorksData'
import { kitPreviewIneditosData } from '../components/KitPreview/KitPreviewData'
import { nextIneditosData } from '../components/NextKit/NextKitData'
import { ineditosTopicsData } from '../components/TAGTopics/TAGTopicsData'
import { clubIneditosData } from '../components/ClubSubscription/ClubSubscriptionData'
import Newsletter from '../components/Newsletter/Newsletter'
import useChatbot from '../helpers/useChatbot'
import { graphql } from 'gatsby'
import PropTypes from 'prop-types'

const ineditosTheme = {
  'bannerBackgroundColor': '#f0e5cc',
  'clubMainColor': '#ff9e16',
  'clubSecondaryColor': '#ea821b',
  'howItWorksSubtitleLineHeight': '1.8',
  'howItWorksTitleMaxWidth': '250px',
  'largeSelector': true,
  'planSelectorBackgroundColor': '#ff9e16',
  'planSelectorUncheckedButtonColor': '#96a0c0',
  'topicsBackgroundColor': '#ffa639',
  'topicsNumberColor': '#ffc97e',
}

const Ineditos = ( { data } ) => {
  const [ videoModalOpen, setVideoModalOpen ] = useState( false )
  useChatbot()
  const { 'allStrapiIneditos': { edges } } = data
  const [ strapiData ] = edges
  const kitPreviewImages =
  {
    'desktopImage': strapiData.node.kitPreviewImage.desktopImage?.localFile?.publicURL,
    'mobileImage': strapiData.node.kitPreviewImage.mobileImage?.localFile?.childImageSharp?.gatsbyImageData.images
  }
  const howItWorksData = { ...strapiData.node.howItWorks, ...howItWorksIneditosDefautlData }
  const kitPreviewData = { ...kitPreviewImages, ...kitPreviewIneditosData }
  const nextKitData = { ...strapiData.node.nextKit, ...nextIneditosData }

  return (
    <>
      {( videoModalOpen &&
        <VideoModal
          onClose={ () => {
            setVideoModalOpen( false )
          } }
          source={ `${process.env.GATSBY_ASSETS_URL}/video_ineditos.mp4` }
        /> )}
      <ThemeProvider theme={ ineditosTheme }>
        <ClubBanner
          playButtonOnClick={ () => {
            setVideoModalOpen( true )
          } }
          { ...clubBannerIneditosData }
        />
        <HowItWorks { ...howItWorksData } />
        <KitPreview { ...kitPreviewData } />
        <PreviousKits club="ineditos" />
        <NextKit { ...nextKitData } />
        <TAGTopics { ...ineditosTopicsData } />
        <ClubSubscription { ...clubIneditosData } />
        <ClubTest />
        <Newsletter />
        <Footer />
      </ThemeProvider>
    </>
  )
}

Ineditos.propTypes = {
  'data': PropTypes.any.isRequired
}

export default Ineditos

export const query = graphql`{
  allStrapiIneditos(limit: 1, sort: {order: DESC, fields: strapiId}) {
    edges {
      node {
        howItWorks {
          column {
            id
            subtitle
            title
          }
          title
        }
        kitPreviewImage {
          desktopImage {
            localFile {
              publicURL
            }
          }
          mobileImage {
            localFile {
              childImageSharp {
                gatsbyImageData
              }
            }
          }
        }
        nextKit {
          title
          description
          items {
            id
            subtitle
            icon {
              url
              alternativeText
            }
          }
        }
      }
    }
  }
}

`
